import { VendorRentalDetailPage } from "@/features/vendor-app/pages/VendorRentalDetailPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/vendor/rental/$vendorConsignmentRentalPaymentID/",
)({
	component: VendorRentalDetailPage,
});
